<template>
    <div class="app-container">
      <BjDivider>
        {{ $t('WarehouseManagement.form.Basic') }}
        <template #right>
          <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        </template>
      </BjDivider>
      <div class="bj-row mt20">
        <div class="bj-col-12" style="padding-left: 0">
            <div class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsCom.invoiceNo') }}</div>
                <div class="bj-form-item-value">{{ invoiceNumber }}</div>
            </div>
            <div class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('OrderPostage.time') }}</div>
                <div class="bj-form-item-value">{{ invoiceDate }}</div>
            </div>
            <div class="bj-form-item">
                <div class="bj-form-item-label">CSV</div>
                <div class="bj-form-item-value">
                  <a v-if="csvUrl" :href="csvUrl">
                    <el-button type="primary">{{ $t('billingPage.Download') }}</el-button>
                  </a>
                </div>
            </div>
        </div>
        <div class="bj-col-12">
            <div class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('InternalOrderList.company') }}</div>
                <div class="bj-form-item-value">{{ logisticsCompany }}</div>
            </div>
            <div class="bj-form-item">
                <div class="bj-form-item-label">{{ $t('OrderPostage.create') }}</div>
                <div class="bj-form-item-value">{{ creationDate }}</div>
            </div>
            <div class="bj-form-item">
                <div class="bj-form-item-label">PDF</div>
                <div class="bj-form-item-value">
                  <a v-if="pdfUrl" :href="pdfUrl">
                    <el-button type="primary">{{ $t('billingPage.Download') }}</el-button>
                  </a>
                </div>
            </div>
        </div>
      </div>

    <!-- <template>
        <BjDivider>{{ $t('OrderPostage.not') }}
          <template slot="right">
            <el-button type="primary" @click="unmatchedExport()">{{ $t('exportText') }}</el-button>
          </template>
        </BjDivider>
        <el-table :data="data.goodsList1" border script max-height="600px">
            <el-table-column type="index" width="60" align="center" :label="$t('table.countText')" />
            <el-table-column prop="consignmentNumber" :label="$t('OrderPostage.logitisic')" align="center" />
            <el-table-column prop="freightCharge" :label="$t('OrderPostage.Freight')" align="center"></el-table-column>
            <el-table-column prop="freightChargeGst" :label="$t('OrderPostage.tax')" align="center"></el-table-column>
            <el-table-column prop="fuelCharge" :label="$t('OrderPostage.cost')" align="center"></el-table-column>
            <el-table-column prop="fuelChargeGst" :label="$t('OrderPostage.Fuel')" align="center"></el-table-column>
            <el-table-column prop="totalInvoiceAmount" :label="$t('OrderPostage.after')" align="center"></el-table-column>
            <el-table-column v-if="logisticsCompany == 'HUNT'" prop="preAdditionalTotalAmount" :label="$t('OrderPostage.ExtraTax')" align="center"></el-table-column>
            <el-table-column v-if="logisticsCompany == 'ALLI'" prop="invoiceNotes" :label="$t('OrderPostage.invoiceNotes')" align="center"></el-table-column>
        </el-table>
    </template> -->

    <template>
        <BjDivider>{{ $t('OrderPostage.yet') }}
          <template slot="right">
            <el-button type="primary" @click="onmatchedExport()">{{ $t('exportText') }}</el-button>
          </template>
        </BjDivider>
        <el-table border script max-height="545px" :data="data.goodsList2">
            <el-table-column type="index" width="60" align="center" :label="$t('table.countText')" />
            <el-table-column prop="consignmentNumber" :label="$t('OrderPostage.logitisic')" align="center"></el-table-column>
            <el-table-column prop="outerOrderNo" :label="$t('OrderPostage.outer')" align="center"></el-table-column>
            <el-table-column prop="matchType" :label="$t('BjDialogListConfig.Types')" align="center"></el-table-column>
            <el-table-column v-if="!$store.getters.cusId" prop="cusId" :label="$t('billingPage.CustomerName')" align="center">
              <template v-slot="{ row }">
                {{ customerList.bjGet(row.cusId) }}
              </template>
            </el-table-column>
            <el-table-column prop="profitMargin" :label="$t('BusinessPurchaseComponentsCom.Profit')" align="center"></el-table-column>
            <el-table-column prop="recoveryStatus" :label="$t('BusinessPurchaseComponentsCom.RecoveryStatus')" align="center">
              <template v-slot="{ row }">
                {{row.recoveryStatus?$t('BusinessPurchaseComponentsCom.Recovered'):$t('BusinessPurchaseComponentsCom.NotRecovered')}}
              </template>
            </el-table-column>
            <el-table-column prop="recoveredAmount" :label="$t('BusinessPurchaseComponentsCom.amount')" align="center"></el-table-column>
            <!-- 发票收费明细 -->
            <el-table-column prop="" :label="$t('OrderPostage.fee')" align="center">
              <el-table-column prop="freightCharge" :label="$t('OrderPostage.Freight')" align="center"></el-table-column>
              <el-table-column prop="freightChargeGst" :label="$t('OrderPostage.tax')" align="center"></el-table-column>
              <el-table-column prop="fuelCharge" :label="$t('OrderPostage.cost')" align="center"></el-table-column>
              <el-table-column prop="fuelChargeGst" :label="$t('OrderPostage.Fuel')" align="center"></el-table-column>
              <el-table-column prop="totalInvoiceAmount" :label="$t('OrderPostage.after')" align="center"></el-table-column>
              <el-table-column v-if="logisticsCompany == 'HUNT'" prop="preAdditionalTotalAmount" :label="$t('OrderPostage.ExtraTax')" align="center"></el-table-column>
              <el-table-column v-if="logisticsCompany == 'DIFE'" prop="preOverweightTotalAmount" :label="$t('OrderPostage.taxsurcharge')" align="center"></el-table-column>
              <el-table-column v-if="logisticsCompany == 'DIFE'" prop="preExtraLongTotalAmount" :label="$t('OrderPostage.taxextra')" align="center"></el-table-column>
              <el-table-column v-if="logisticsCompany == 'DIFE'" prop="preResendTotalAmount" :label="$t('OrderPostage.taxreturn')" align="center"></el-table-column>
            </el-table-column>
            <!-- ERP收费明细 -->
            <el-table-column prop="" :label="$t('OrderPostage.ERP')" align="center">
              <el-table-column prop="freightChargeErp" :label="$t('OrderPostage.Freight')" align="center"></el-table-column>
              <el-table-column prop="fuelChargeErp" :label="$t('OrderPostage.cost')" align="center"></el-table-column>
              <el-table-column prop="totalGstErp" :label="$t('OrderPostage.Totals')" align="center"></el-table-column>
              <el-table-column prop="totalPriceErp" :label="$t('OrderPostage.amount')" align="center"></el-table-column>
              <el-table-column prop="preTotalPriceErp" :label="$t('OrderPostage.after')" align="center"></el-table-column>
            </el-table-column>
            <el-table-column prop="percentage" :label="$t('OrderPostage.lose')" align="center"></el-table-column>
            <el-table-column prop="difference" :label="$t('OrderPostage.over')" align="center"></el-table-column>
            <el-table-column v-if="logisticsCompany == 'ALLI'" prop="invoiceNotes" :label="$t('OrderPostage.invoiceNotes')" align="center"></el-table-column>
        </el-table>
    </template>
    </div>
  </template>
  <script>
  import viewMiXin from '@/utils/view-mixin.js';
  import { exportFile } from '@/utils/index';
  // import { downloadBlob } from '@/utils/index';
  import { orderApi } from '@/api';

  export default {
    components: {},
    mixins: [viewMiXin],
    props: {},
    data() {
      return {
        invoiceNumber: '',
        logisticsCompany: '',
        invoiceDate: '',
        creationDate: '',
        csvUrl: '',
        pdfUrl: '',
        data: {
            goodsList1: [],
            goodsList2: [],
        },
        size: 0,
       };
    },
    mounted() {
      this.getData();
    },
    computed: {
      customerList() {
        return this.$store.getters.customerList;
      },
    },
    methods: {
      handleClose() {
        this.cancel();
      },
      getData() {
        // 详情页列表返回
        orderApi.getPostageDetail({invoiceId: this.$route.query.id}).then(res => {
            if (!res.failed) {
                this.invoiceNumber = res.invoiceNumber;
                this.logisticsCompany = res.logisticsCompany;
                this.invoiceDate = res.invoiceDate;
                this.creationDate = res.creationDate;
                this.csvUrl = res.csvUrl;
                this.pdfUrl = res.pdfUrl;
            }
        });
        // // 不匹配列表返回
        // orderApi.getPostageDetailUNMatch({invoiceId: this.$route.query.id}).then(res => {
        //     if (!res.failed) {
        //         this.data.goodsList1 = res.content || [];
        //     }
        // });
        // 匹配列表返回
        orderApi.getPostageDetailMatch({invoiceId: this.$route.query.id}).then(res => {
            if (!res.failed) {
                this.data.goodsList2 = res.content || [];
            }
        });
      },
      // 下拉框选完数据后刷新 匹配项目列表
      doSome(n, m, z) {
        this.size = n;
        orderApi.getPostageDetailMatch({invoiceId: this.$route.query.id, difference: n}).then(res => {
            if (!res.failed) {
                this.data.goodsList2 = res.content || [];
            }
        });
      },
      // 前端导出 不匹配项目组
      unmatchedExport() {
          const fileName = `${this.logisticsCompany}_${this.invoiceNumber}_1.csv`;
          if (!this.data.goodsList1.length) return this.$message.warning(this.$t('table.emptyText'));
          const tableData = [];
          let headers = [
            'Logistics Waybill Number',
            'Freight',
            'Freight Tax',
            'Fuel Fee',
            'Fuel Tax',
            'Total Pre Tax Amount'
          ];
          if (this.logisticsCompany == 'HUNT') {
            headers = [...headers, 'Extra tax'];
          } else if (this.logisticsCompany == 'ALLI') {
            headers = [...headers, 'Notes'];
          }

          this.data.goodsList1.forEach((res) => {
            const obj = {
              'Logistics Waybill Number': res.consignmentNumber || '',
              'Freight': res.freightCharge || '',
              'Freight Tax': res.freightChargeGst || '',
              'Fuel Fee': res.fuelCharge || '',
              'Fuel Tax': res.fuelChargeGst || '',
              'Total Pre Tax Amount': res.totalInvoiceAmount || '',
            };
            if (this.logisticsCompany == 'HUNT') {
              tableData.push({ ...obj, 'Extra tax': res.preAdditionalTotalAmount || '' });
            } else if (this.logisticsCompany == 'ALLI') {
              tableData.push({ ...obj, 'Notes': res.invoiceNotes || '' });
            } else {
              tableData.push(obj);
            }
          });
          exportFile(fileName, tableData, headers, 'worksheet1');
      },
      // 前端导出 匹配项目组
      onmatchedExport() {
          const fileName = `${this.logisticsCompany}_${this.invoiceNumber}_2.csv`;
          if (!this.data.goodsList2.length) return this.$message.warning(this.$t('table.emptyText'));
          const tableData = [];
          const prefix = ['Platform Order Number', 'Logistics Waybill Number', 'Type', 'Invoice Freight',
            'Invoice Freight Tax', 'Invoice Fuel Fee', 'Invoice Fuel Tax', 'Invoice Total Pre Tax Amount'];
          const after = ['ERP Freight', 'ERP Fuel Fee', 'ERP Total Tax Amount', 'ERP Total Amount', 'ERP Total Pre Tax Amount',
            'Percentage Difference', 'Difference'];
          let headers = [...prefix, ...after];
          if (this.logisticsCompany == 'HUNT') {
            headers = [...prefix, 'Extra tax', ...after];
          } else if (this.logisticsCompany == 'DIFE') {
            // headers = [...headers, 'Notes']
          } else if (this.logisticsCompany == 'ALLI') {
            headers = [...headers, 'Notes'];
          }

          this.data.goodsList2.forEach((res) => {
            const objPre = {
              'Logistics Waybill Number': res.consignmentNumber || '',
              'Platform Order Number': res.outerOrderNo || '',
              'Type': res.matchType || '',
              'Invoice Freight': res.freightCharge || '',
              'Invoice Freight Tax': res.freightChargeGst || '',
              'Invoice Fuel Fee': res.fuelCharge || '',
              'Invoice Fuel Tax': res.fuelChargeGst || '',
              'Invoice Total Pre Tax Amount': res.totalInvoiceAmount || '',
            };
            const objAfter = {
              'ERP Freight': res.freightChargeErp || '',
              'ERP Fuel Fee': res.fuelChargeErp || '',
              'ERP Total Tax Amount': res.totalGstErp || '',
              'ERP Total Amount': res.totalPriceErp || '',
              'ERP Total Pre Tax Amount': res.preTotalPriceErp || '',
              'Percentage Difference': res.percentage || '',
              'Difference': res.difference || '',
            };
            let obj = { ...objPre, ...objAfter};
            if (this.logisticsCompany == 'HUNT') {
                obj = {
                  ...objPre,
                  'Extra tax': res.preAdditionalTotalAmount || '',
                  ...objAfter
                };
            } else if (this.logisticsCompany == 'ALLI') {
                obj = {
                  ...obj, 'Notes': res.invoiceNotes || ''
                };
            } else if (this.logisticsCompany == 'DIFE') {
                obj = {
                  ...objPre,
                  'Overweight fee (excl. GST)': res.preOverweightTotalAmount || '',
                  'Excess length fee (excl. GST)': res.preExtraLongTotalAmount || '',
                  'Return and reissue fee (excl. GST)': res.preResendTotalAmount || '',
                  ...objAfter
                };
            }
            tableData.push(obj);
          });
          exportFile(fileName, tableData, headers, 'worksheet1');
      },
      // 后端导出，暂时弃用
      // unmatchedExport() {
      //   orderApi.unmatchedPostageExport({invoiceId: this.$route.query.id}).then(res => {
      //     if (!res.failed) {
      //       downloadBlob(res, this.$t('OrderPostage.not') + new Date().toLocaleString() + '.xlsx');
      //     } else {
      //       this.$message.error(res.message);
      //     }
      //   });
      // },
      // onmatchedExport() {
      //   orderApi.matchedPostageExport({invoiceId: this.$route.query.id,difference:this.size}).then(res => {
      //     if (!res.failed) {
      //       downloadBlob(res, this.$t('OrderPostage.yet') + new Date().toLocaleString() + '.xlsx');
      //     } else {
      //       this.$message.error(res.message);
      //     }
      //   });
      // },
    },
  };
  </script>
  <style lang="scss" scoped>
  .flex-center {
    justify-content: left;
  }
  .numBox {
    position: relative;
    flex: 0 0 150px;
    padding-bottom: 15px;
  }
  .numBox p {
    font-size: 12px;
  }
  .numBox::after {
    position: absolute;
    content: '';
    height: 5px;
    bottom: 0;
    left: 15px;
    right: 15px;
    display: block;
    // background-color: red;
  }
  .numBox:nth-child(1):after {
    background-color: $pink;
  }
  .numBox:nth-child(2):after {
    background-color: $green;
  }
  .numBox:nth-child(3):after {
    background-color: $sub-dark;
  }
  .numBox:nth-child(4):after {
    background-color: yellowgreen;
  }
  </style>
